<template>
    <article class="level">
        <div class="level-left">
            <div class="level-item">
                <p class="image is-24x24">
                    <img
                        v-if="!user.image"
                        :src="user.avatar"
                        class="is-rounded"
                    />
                    <img v-else :src="user.image.url" class="is-rounded" />
                </p>
            </div>
            <div class="level-item">
                <div>
                    <p class="has-text-weight-bold">
                        {{ user.username }}
                    </p>
                    <p class="is-size-7">
                        {{ user.email }}
                    </p>
                </div>
            </div>
        </div>
        <div class="level-right">
            <div class="level-item">
                <slot name="action" />
            </div>
        </div>
    </article>
</template>

<script>
export default {
    props: {
        user: {
            type: Object,
            required: true,
            default() {
                return {};
            },
        },
    },
};
</script>

<style></style>
